
import { BlackBoxDeviceEvent } from "src/model/enum/enumBlackBox";
import { ExtraInfoBlackBox } from "./extra-info-black-box";

export class BlackBoxEntry {
  public instanceGuid: string;
  public dateTime: string = new Date().toISOString();
  public typeAction: BlackBoxDeviceEvent = BlackBoxDeviceEvent.READ_TAG;
  public extraInfo: ExtraInfoBlackBox;

  constructor(blackBoxEntry?: any) {
    // used for assign type to instance of object
    if (blackBoxEntry) {
      Object.assign(this, blackBoxEntry);
    }
  }
}
